// MissingFloat is used when a value is determined to be "missing". We're
// doing this because numeric zero is a valid value and can't be used as
// the "zero" value when you're dealing with things like elevation, river
// flow, stage height, etc.. -9999/-999 is an AHPS established value for
// missing data. Thus, we can safely assume that anything greater than -999
// is not missing.
export const MissingFloat = -999
